export const URL_PARAM_CUSTOMER_ID = 'customerId'
export const URL_PARAM_ORDER_STATUS = 'status'
export const URL_PARAM_START_DATE = 'sdateordered'
export const URL_PARAM_END_DATE = 'edateordered'
